import AiAccessPage from './AiAccessPage';
import AccessSettingsTable from './AccessSettingsTable';

// AI Settings > Global: the shared switch and combined daily limit (feature=ALL)
function GlobalSettings() {
  return (
    <AiAccessPage
      title="Shared AI settings"
      description="One switch and one combined daily limit that cover both Ask AI and AI reports. Each feature has its own settings under Ask AI and AI Reporting. System-generated reports are never blocked or counted."
    >
      <AccessSettingsTable
        scope="GLOBAL"
        feature="ALL"
        noun="everyone"
        singular="everyone"
        paged={false}
      />
    </AiAccessPage>
  );
}

export default GlobalSettings;
